var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.1802 12.6533H4.82016C4.54016 12.6533 4.28683 12.4733 4.19349 12.2133L1.42016 4.44665C1.20016 3.82665 1.90683 3.29999 2.43349 3.67999L5.10016 5.58665C5.45349 5.83999 5.96016 5.68665 6.11349 5.27999L7.37349 1.91999C7.58683 1.33999 8.40683 1.33999 8.62016 1.91999L9.88016 5.27999C10.0335 5.69332 10.5335 5.83999 10.8935 5.58665L13.5602 3.67999C14.0935 3.29999 14.7935 3.83332 14.5735 4.44665L11.8002 12.2133C11.7135 12.4733 11.4602 12.6533 11.1802 12.6533Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3327 14.6667H4.66602C4.39268 14.6667 4.16602 14.44 4.16602 14.1667C4.16602 13.8933 4.39268 13.6667 4.66602 13.6667H11.3327C11.606 13.6667 11.8327 13.8933 11.8327 14.1667C11.8327 14.44 11.606 14.6667 11.3327 14.6667Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66732 9.83334H6.33398C6.06065 9.83334 5.83398 9.60668 5.83398 9.33334C5.83398 9.06001 6.06065 8.83334 6.33398 8.83334H9.66732C9.94065 8.83334 10.1673 9.06001 10.1673 9.33334C10.1673 9.60668 9.94065 9.83334 9.66732 9.83334Z",
    fill: "#292D32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.7b069166b7dce2f17c4230cf8ca64d0c.svg";
export { ForwardRef as ReactComponent };